import Typography from "@mui/joy/Typography";

function NotFound() {
  return (
    <>
      <div style={{ padding: "75px 50px 50px 50px" }}>
        <Typography
          level="title-lg"
          style={{
            fontSize: "3rem",
            marginBottom: "20px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          404 – Page Not Found
        </Typography>
        <div style={{ maxWidth: "600px", margin: "0 auto" }}>
          <Typography level="body-lg">
            Well, this is awkward. You’ve reached a part of my site that doesn’t
            exist.
          </Typography>
          <br />
          <Typography level="body-lg">
            It’s possible the link is broken, the page was moved, you typed
            something weird, or I made a mistake. Try heading back{" "}
            <a href="/">home</a>.
          </Typography>
        </div>
      </div>
    </>
  );
}

export default NotFound;
